export const config = {
  title:
    'AI-BASED PLATFORM\nFOR IMPROVING\nDIAGNOSTIC ACCURACY\nAND PATIENT TREATMENT\nEFFECTIVENESS ',
  image: {
    src: '/images/cases/ai-based-platform.webp',
    alt: 'AI-based platform',
    title: 'AI-based platform',
    width: 461,
    height: 377,
  },
  imageMobile: {
    src: '/images/cases/ai-based-platform-mobile.webp',
    alt: 'AI-based platform',
    title: 'AI-based platform',
    width: 630,
    height: 470,
  },
  background: {
    src: '/images/cases/background-ai-based-platform.webp',
    alt: 'AI-based platform',
    title: 'AI-based platform',
    width: 1440,
    height: 720,
    quality: 100,
  },
}
